import { GEOMETRYTYPE } from "../featuretree/internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * Edit Feature Tool
 * @class EditFeatureTool
 * @extends {Tool}
 */
export class EditFeatureTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        this.singleActive = false;
        this.selectinputevent = null;
        this.resetinputevent = null;
        this.mousemoveevent = null;
        this.mouseupevent = null;
        this.deletekeyevent = null;
        this.mouseoutevent = null;
        this.dragon = false;
        this.snap_mx = null;
        this.snap_my = null;
        this.snappedpos = null;
        this.selectedpointdata = null;
        this.selectedfeature = null;
        this.name = name;
        this.group = group;
        //options - set the default values here....
        const defaultoptions = {
            selectinput: USERINPUTTYPE.LEFTCLICK,
            resetinput: USERINPUTTYPE.RIGHTCLICK,
            activecursor: "default",
            maxdist: 30,
            edit: true,
            editedcbf: null,
            selectedcbf: null,
            deselectedcbf: null,
            hovercbf: null,
            continuouseditcbf: null,
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
    }
    /**
     * internal function - to activate tool call mmSelectFeatureTool.enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this._subscribeEvents();
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        this.fire(EditFeatureTool.enabled, this.options["cbobject"]);
    }
    /**
     * internal function - to disable tool call mmSelectFeatureTool.disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        //if tool is not active there is nothing to disable...
        if (!this.enabled)
            return;
        if (this.selectedpointdata != null) {
            this.selectedpointdata.feature.highlightOff();
        }
        this._stopdragging(null);
        this.reset();
        this.scene.getCursorStyleHandler().setCursorStyle("default");
        this.fire(EditFeatureTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
    }
    _subscribeEvents() {
        this.mousemoveevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._hoverFeature, this);
        if (this.options.resetinput != null) {
            this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        if (this.options.selectinput != null) {
            this.selectinputevent = this.scene.userInputHandler.subscribeEvent(this.options.selectinput, this._selectfeature, this);
        }
        if (this.options.enablecbf != null) {
            this.on(EditFeatureTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(EditFeatureTool.disabled, this.options.disablecbf);
        }
        if (this.options.selectedcbf != null) {
            this.on(EditFeatureTool.selected, this.options.selectedcbf);
        }
        if (this.options.deselectedcbf != null) {
            this.on(EditFeatureTool.deselected, this.options.deselectedcbf);
        }
        if (this.options.hovercbf != null) {
            this.on(EditFeatureTool.hovered, this.options.hovercbf);
        }
        if (this.options.continuouseditcbf != null) {
            this.on(EditFeatureTool.continousedit, this.options.continuouseditcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(EditFeatureTool.reset, this.options.resetcbf);
        }
        if (this.options.editedcbf != null) {
            this.on(EditFeatureTool.edited, this.options.editedcbf);
        }
        if (this.options.errorcbf != null) {
            this.on(EditFeatureTool.error, this.options.errorcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this.resetinputevent);
        this.resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.selectinput, this.selectinputevent);
        this.selectinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupevent);
        this.mouseupevent = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseoutevent);
        this.mouseoutevent = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_DELETE, this.deletekeyevent);
        this.deletekeyevent = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveevent);
        this.mousemoveevent = null;
        if (this.options.enablecbf != null) {
            this.off(EditFeatureTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(EditFeatureTool.disabled, this.options.disablecbf);
        }
        if (this.options.selectedcbf != null) {
            this.off(EditFeatureTool.selected, this.options.selectedcbf);
        }
        if (this.options.deselectedcbf != null) {
            this.off(EditFeatureTool.deselected, this.options.deselectedcbf);
        }
        if (this.options.hovercbf != null) {
            this.off(EditFeatureTool.hovered, this.options.hovercbf);
        }
        if (this.options.continuouseditcbf != null) {
            this.off(EditFeatureTool.continousedit, this.options.continuouseditcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(EditFeatureTool.reset, this.options.resetcbf);
        }
        if (this.options.editedcbf != null) {
            this.off(EditFeatureTool.edited, this.options.editedcbf);
        }
        if (this.options.errorcbf != null) {
            this.off(EditFeatureTool.error, this.options.errorcbf);
        }
    }
    /**
     * Function is fired on the selectinputevent
     * @method _selectfeature
     * @private
     */
    _selectfeature(evt) {
        if (this.selectedfeature)
            this.selectedfeature.highlightOff();
        const mx = evt.offsetX;
        const my = evt.offsetY;
        const featureHandler = this.scene.getFeatureHandler();
        const pickdataarray = featureHandler.pick(mx, my, this.options.picklayer);
        this.selectedpointdata = null;
        //somethjng hit!
        if (pickdataarray != null) {
            //highlight the first feature wich was hit
            const pickedfeature = pickdataarray[0].feature;
            this.selectedfeature = pickedfeature; //store for deselection
            pickedfeature.highlightOn();
            //check if a point was hit
            for (let i = 0; i < pickdataarray.length; i++) {
                if (pickdataarray[i].feature == pickedfeature) {
                    if (pickdataarray[i].geometry.type == GEOMETRYTYPE.MULTIPOINT ||
                        pickdataarray[i].geometry.type == GEOMETRYTYPE.POINT) {
                        this.selectedpointdata = pickdataarray[i];
                        this.fire(EditFeatureTool.selected, this.options["cbobject"], this.selectedpointdata.feature, this.selectedpointdata.pointindex, evt);
                    }
                }
            }
            if (this.selectedpointdata == null) {
                this.fire(EditFeatureTool.selected, this.options["cbobject"], pickedfeature, -1, evt);
                return;
            }
            this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_DELETE, this.deletekeyevent);
            this.deletekeyevent = null;
            this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseoutevent);
            this.mouseoutevent = null;
            //Check if a point on the feature was selected and if so enable dragging
            if (!this.dragon && this.options.edit) {
                //CTRL and Drag -> insert a new point...
                if (evt.ctrlKey) {
                    this.selectedpointdata.feature.insertPoint(this.selectedpointdata.pointindex);
                    this.selectedpointdata.pointindex += 1;
                }
                this.selectedpointdata.feature.highlightPointOn(this.selectedpointdata.pointindex);
                //disable mousemove for featureinfo and activate the mousemove events for point dragging
                this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveevent);
                this.mousemoveevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._dragfeaturepoint, this);
                this.mouseupevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._stopdragging, this);
                //activate the KEY_PRESS for deleting the point
                this.deletekeyevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_DELETE, this._deletePoint, this);
                //disable drag mode onmouseout
                this.mouseoutevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEOUT, this._stopdragging, this);
                this.dragon = true;
                this.scene.infrascene.lockNavigation();
            }
        }
        else if (!this.dragon && this.selectedfeature != null) {
            this.selectedfeature.highlightOff();
            this.fire(EditFeatureTool.deselected, this.options["cbobject"], this.selectedfeature, evt);
        }
    }
    _hoverFeature(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        const featureHandler = this.scene.getFeatureHandler();
        const pickdataarray = featureHandler.pick(mx, my, this.options.picklayer);
        this.fire(EditFeatureTool.hovered, this.options["cbobject"], pickdataarray, evt);
    }
    /**
     *  moves the selected point on mousemove event...
     *  @method _dragfeaturepoint
     *  @param evt the event data
     *  @private
     */
    _dragfeaturepoint(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        const feature = this.selectedpointdata.feature;
        const pointindex = this.selectedpointdata.pointindex;
        const pos = this.scene
            .getMeasureHandler()
            .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist);
        if (this.options.snaplayer && !evt.altKey) {
            const snapdataarray = this.scene.getFeatureHandler().snap(mx, my, this.options.snaplayer);
            if (snapdataarray.length > 0) {
                //prevent self pickcing and filter non-pointy geometries
                for (let i = snapdataarray.length - 1; i >= 0; i--) {
                    if ((snapdataarray[i].feature == feature && snapdataarray[i].pointindex == pointindex) ||
                        (snapdataarray[i].geometry.type != GEOMETRYTYPE.MULTIPOINT &&
                            snapdataarray[i].geometry.type != GEOMETRYTYPE.POINT)) {
                        snapdataarray.splice(i, 1);
                    }
                }
                if (snapdataarray.length > 0) {
                    const snapdata = snapdataarray[0];
                    this.snap_mx = snapdata.found_mx;
                    this.snap_my = snapdata.found_my;
                    pos.Easting = snapdata.found_easting;
                    pos.Northing = snapdata.found_northing;
                    pos.Height = snapdata.found_height;
                    pos.warning = false;
                    this.snappedpos = pos;
                }
            }
            else {
                this.snap_mx = null;
                this.snap_my = null;
                this.snappedpos = null;
            }
        }
        if (pos.warning) {
            this.fire(EditFeatureTool.error, this.options["cbobject"], pos.warntext, evt);
            this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
            return;
        }
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        if (evt.shiftKey) {
            if (feature.geometry.type == GEOMETRYTYPE.POINT) {
                pos.Easting = feature.geometry.coordinates[0][0];
                pos.Northing = feature.geometry.coordinates[0][1];
            }
            else if (feature.geometry.type == GEOMETRYTYPE.POLYGON) {
                pos.Easting = feature.geometry.coordinates[pointindex][0];
                pos.Northing = feature.geometry.coordinates[pointindex][1];
            }
            else {
                pos.Easting = feature.geometry.coordinates[pointindex][0];
                pos.Northing = feature.geometry.coordinates[pointindex][1];
            }
        }
        feature.movePoint([pos.Easting, pos.Northing, pos.Height], pointindex);
        if (this.dragon) {
            this.fire(EditFeatureTool.continousedit, this.options["cbobject"], [pos.Easting, pos.Northing, pos.Height], pointindex, evt, feature.toGeoJSON());
        }
        feature.update(true);
    }
    /**
     *  deselects all features and releases the aborted callback
     *  @method _stopdragging
     *  @private
     */
    _stopdragging(evt) {
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        this.scene.infrascene.unlockNavigation();
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveevent);
        this.mousemoveevent = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._hoverFeature, this);
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupevent);
        this.mouseupevent = null;
        if (this.dragon) {
            this.fire(EditFeatureTool.edited, this.options["cbobject"], this.selectedpointdata.feature, this.selectedpointdata.pointindex, evt);
        }
        this.dragon = false;
        this.type = "EditFeatureTool";
    }
    /**
     * deselects all features and releases the aborted callback
     * @method reset
     * @param {?Object} evt EventObject if called from userinput
     * @public
     */
    reset(evt) {
        if (this.selectedpointdata != null) {
            this.selectedpointdata.feature.highlightOff();
        }
        this.selectedpointdata = null;
        this.fire(EditFeatureTool.reset, this.options["cbobject"], evt);
    }
    /**
     * deletes a point in the selected feature
     * @method _deletePoint
     * @private
     */
    _deletePoint(evt) {
        if (this.selectedpointdata != null) {
            const feature = this.selectedpointdata.feature;
            const pointindex = this.selectedpointdata.pointindex;
            feature.deletePoint(pointindex);
            this.fire(EditFeatureTool.edited, this.options["cbobject"], this.selectedpointdata.feature, this.selectedpointdata.pointindex, evt);
        }
    }
    /**
     * checkes if the selected feature is already selected
     * @method _isselected
     * @param {Feature} feature
     * @return {boolean}
     * @private
     */
    _isselected(feature) {
        if (this.selectedpointdata != null) {
            return feature == this.selectedpointdata.feature;
        }
    }
}
EditFeatureTool.enabled = "enabled";
EditFeatureTool.disabled = "disabled";
EditFeatureTool.selected = "selected";
EditFeatureTool.deselected = "deselected";
EditFeatureTool.hovered = "hovered";
EditFeatureTool.continousedit = "continousedit";
EditFeatureTool.edited = "edited";
EditFeatureTool.reset = "reset";
EditFeatureTool.error = "error";
//# sourceMappingURL=editfeaturetool.js.map